// components/alerts/AlertComponents.tsx
import React from 'react';
import SpeedAlarm from './TypeAlarms/SpeedAlarm';
import PoiAlarm from './TypeAlarms/PoiAlarm';
import AbsenceOfTransmission from './TypeAlarms/AbsenceOfTransmission';

import OdometerCAN from './TypeAlarms/OdometerCAN';
import OdometerGPS from './TypeAlarms/OdometerGPS';
import EngineSpeedCAN from './TypeAlarms/EngineSpeedCAN';
import UnderVoltage from './TypeAlarms/UnderVoltage';
import OverVoltage from './TypeAlarms/OverVoltage';
import EngineTemperatureCAN from './TypeAlarms/EngineTemperatureCAN';
import DailyMobileData from './TypeAlarms/DailyMobileData';
import MonthlyMobileData from './TypeAlarms/MonthlyMobileData';

import GsmSignalAlarm from './TypeAlarms/GsmSignalAlarm';
import DateTimeAlarm from './TypeAlarms/DateTimeAlarm';
import GPSSignalAlarm from './TypeAlarms/GPSSignalAlarm';
import SIMCreditAlarm from './TypeAlarms/SIMCreditAlarm';
import PowerAlarm from './TypeAlarms/PowerAlarm';
import BatteryAlarm from './TypeAlarms/BatteryAlarm';
import ResetAlarm from './TypeAlarms/ResetAlarm';
import SpeedExceedAlarm from './TypeAlarms/SpeedExceedAlarm';
import POIAlarmSpeedViolation from './TypeAlarms/POIAlarmSpeedViolation';


interface AlarmProps {
  alarm: any; // Adapter le type en fonction de votre structure d'alarme
  onChange: (newMetrics: any) => void;
}

const alertComponents: { [key: number]: React.FC<AlarmProps> } = {
  48: ({ alarm, onChange }) => <SpeedAlarm alarm={alarm} onChange={onChange} />,
  2:  PoiAlarm,
  3:  ({ alarm, onChange }) => <AbsenceOfTransmission alarm={alarm} onChange={onChange} />,
  9:  ({ alarm, onChange }) => <SIMCreditAlarm alarm={alarm} onChange={onChange} />,
  14: ({ alarm, onChange }) => <PowerAlarm alarm={alarm} onChange={onChange} />,
  15: ({ alarm, onChange }) => <BatteryAlarm alarm={alarm} onChange={onChange} />,
  17: ({ alarm, onChange }) => <DateTimeAlarm alarm={alarm} onChange={onChange} />,
  18: ({ alarm, onChange }) => <SpeedExceedAlarm alarm={alarm} onChange={onChange} />,
  29: ({ alarm, onChange }) => <GPSSignalAlarm alarm={alarm} onChange={onChange} />,
  30: ({ alarm, onChange }) => <GsmSignalAlarm alarm={alarm} onChange={onChange} />,
  31: ({ alarm, onChange }) => <ResetAlarm alarm={alarm} onChange={onChange} />,
  32: ({ alarm, onChange }) => <OdometerCAN alarm={alarm} onChange={onChange} />,
  33: ({ alarm, onChange }) => <OdometerGPS alarm={alarm} onChange={onChange} />,
  37: ({ alarm, onChange }) => <EngineSpeedCAN alarm={alarm} onChange={onChange} />,
  40: ({ alarm, onChange }) => <UnderVoltage alarm={alarm} onChange={onChange} />,
  44: ({ alarm, onChange }) => <OverVoltage alarm={alarm} onChange={onChange} />,
  45: ({ alarm, onChange }) => <EngineTemperatureCAN alarm={alarm} onChange={onChange} />,
  46: ({ alarm, onChange }) => <DailyMobileData alarm={alarm} onChange={onChange} />,
  47: ({ alarm, onChange }) => <MonthlyMobileData alarm={alarm} onChange={onChange} />,
  49: PoiAlarm,
  50: POIAlarmSpeedViolation,

  // Ajoutez d'autres composants d'alerte ici
};


export default alertComponents;
